// Formatting helpers shared across booking/admin components — minutes-since-
// midnight to "HH:MM", euro amounts, and local-calendar-day Date <-> key
// conversions used by the booking and admin-panel calendars.
export function formatMinutesAsTime(minutes) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
}
export function formatEuros(amount) {
    return `€${Number.isInteger(amount) ? String(amount) : amount.toFixed(2)}`;
}
export function formatCentsAsEuros(cents) {
    return formatEuros(cents / 100);
}
// `YYYY-MM-DD` using local getters, matching what a Date picker shows.
export function dateKeyLocal(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export function isSameLocalDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
// Booking instants are Unix seconds on the app's UTC calendar-day convention
// (no per-visitor timezone handling — see CLAUDE.md), so both ends are read
// with UTC getters, not the viewer's local time.
export function formatUtcTimeRange(dateStartUnix, dateEndUnix) {
    const toMinutesOfDay = (unixSeconds) => {
        const date = new Date(unixSeconds * 1000);
        return date.getUTCHours() * 60 + date.getUTCMinutes();
    };
    return `${formatMinutesAsTime(toMinutesOfDay(dateStartUnix))}–${formatMinutesAsTime(toMinutesOfDay(dateEndUnix))}`;
}
